import { useEffect, useState } from 'react';
import api from '@/api';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import { Col, Row } from 'antd';
import moment from 'moment';
import { FORMAT_DATE_GENERAL_EXCEPT_TIME } from '@/constants/constant';

const ManageUsageHistoryPage = () => {
  const { current: company } = useSelector((state: RootState) => state.company);
  const [usageHistoryList, setUsageHistoryList] = useState<any[]>([]);

  const from = moment().startOf('month').format(FORMAT_DATE_GENERAL_EXCEPT_TIME);
  const to = moment().format(FORMAT_DATE_GENERAL_EXCEPT_TIME);

  useEffect(() => {
    if (company) {
      api.get('/solution/history/daily', { params: { companyId: company?.base?.id, solutionId: 1, from, to } }).then(({ data }) => {
        console.log(data);
      });
    }
  }, [company, from, to]);

  return (
    <div className="p-5">
      <h1 className="text-2xl font-bold mb-5">서비스 이용 내역</h1>

      {company === null && <div>회사 가입 승인 후 사용 가능합니다.</div>}

      {company && usageHistoryList.length === 0 && <div>서비스 이용 내역이 없습니다.</div>}

      {usageHistoryList.map((historyItem) => (
        <Row className="bg-white rounded">
          <Col lg={4}>{historyItem.historyDate}</Col>
          <Col lg={4}>스마트 민원</Col>
          <Col lg={4}>{historyItem.totalAmount}</Col>
          <Col lg={4}>확인하기</Col>
        </Row>
      ))}
    </div>
  );
};

export default ManageUsageHistoryPage;
